const Payment = () => {
  return (
    <div className="text-center p-6">
      <h1 className="text-2xl font-bold mb-4">Payment Page</h1>
      <p>This is for payment gateway integration.</p>
    </div>
  );
};

export default Payment;
